import { render } from "./SchoolDetail.vue?vue&type=template&id=569a406e&scoped=true"
import script from "./SchoolDetail.vue?vue&type=script&lang=js"
export * from "./SchoolDetail.vue?vue&type=script&lang=js"

import "./SchoolDetail.vue?vue&type=style&index=0&id=569a406e&scoped=true&lang=css"
import "./SchoolDetail.vue?vue&type=style&index=1&id=569a406e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-569a406e"]])

export default __exports__